import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-148a815d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "completeInfo" }
const _hoisted_2 = { class: "info block-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-tit" }, "汇报详情", -1))
const _hoisted_4 = { class: "block-con" }
const _hoisted_5 = {
  key: 0,
  class: "pics"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "submit-btn"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "submit-btn"
}

import { projectItem, flowsItem, Approve } from '@/apis/base'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const type_name = ref('')
const completeDetails = ref({
  date: '', // 完结时间
  explain: '', // 说明
  approve_state: 0, // 审批流程
  pics: null, // 图片
  tabsActive: 0, // 已发起
  type_id: 0, // 项目类型
  item_id: 0, // 详情id
  approve: {} as Approve,
  project: {} as projectItem,
  flows: Array<flowsItem>()
})
const showBottom = ref(false)

const StaffInfo = ref({
  id: 0,
  name: '',
  avatar: ''
})

onMounted(() => {
  StaffInfo.value = JSON.parse(localStorage.getItem('STAFFINFO'))
  completeDetails.value = JSON.parse(router.currentRoute.value.query.data.toString())
  type_name.value = router.currentRoute.value.query.type_name.toString()
  let botton: any = router.currentRoute.value.query.button
  showBottom.value = botton
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_DetailTitle = _resolveComponent("DetailTitle")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_PreviewPicture = _resolveComponent("PreviewPicture")!
  const _component_ApprovalProcess = _resolveComponent("ApprovalProcess")!
  const _component_BottomButtonTwo = _resolveComponent("BottomButtonTwo")!
  const _component_BottomButtonOne = _resolveComponent("BottomButtonOne")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_DetailTitle, {
      approve: completeDetails.value.approve
    }, null, 8, ["approve"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_cell_group, {
          title: "项目名称",
          border: false,
          class: "mx-box"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: completeDetails.value?.project?.name,
              size: "large"
            }, null, 8, ["title"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_cell_group, {
          title: "项目完结情况",
          border: false,
          class: "mx-box"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: "完结时间",
              value: completeDetails.value.date
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "完结说明",
              value: completeDetails.value.explain
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        (completeDetails.value.pics)
          ? (_openBlock(), _createBlock(_component_van_cell_group, {
              key: 0,
              title: "图片",
              border: false
            }, {
              default: _withCtx(() => [
                (completeDetails.value.pics)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_PreviewPicture, {
                        imgs: completeDetails.value.pics,
                        radius: 5,
                        width: 65,
                        height: 65
                      }, null, 8, ["imgs"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ApprovalProcess, {
      flows: completeDetails.value.flows
    }, null, 8, ["flows"]),
    (completeDetails.value.tabsActive == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (completeDetails.value.approve.approve_staff?.id === StaffInfo.value.id && completeDetails.value.approve.state == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (showBottom.value)
                  ? (_openBlock(), _createBlock(_component_BottomButtonTwo, {
                      key: 0,
                      typeId: completeDetails.value.type_id,
                      itemId: completeDetails.value.item_id
                    }, null, 8, ["typeId", "itemId"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (completeDetails.value.tabsActive == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (completeDetails.value.approve.staff_id === StaffInfo.value.id && completeDetails.value.flows[1].state == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (showBottom.value)
                  ? (_openBlock(), _createBlock(_component_BottomButtonOne, {
                      key: 0,
                      typeId: completeDetails.value.type_id,
                      itemId: completeDetails.value.item_id
                    }, null, 8, ["typeId", "itemId"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})